import { getGlobalStyles, makeTheme, toMakeTheme, createMakeTheme } from 'bootstrap-styled'
import { createGlobalStyle } from 'styled-components'
import { GlobalStyleProps } from '../typings/styled'
import { unitUtils } from '@bootstrap-styled/utils'
import { appLib } from '../utils/imports'

const { rmUnit, math } = unitUtils

// Global variables for styled theme
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const transformed: Record<string | number | symbol, any> = appLib.extractVars({
    camelCase: false,
    numToStr: true
})

// Create global style component
export const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
    ${getGlobalStyles()}
    html, body {
        font-size: ${props => props.theme['$global-font-size']} !important;
    }
    body {
        padding-top: ${props => props.theme['$nav-link-height']} !important;

        &.navbar-open {
            width: 100%;
            padding-top: 0 !important;
            position: relative;
            overflow-y: hidden;
            height: 100vh;
            background-color: ${props => props.theme['$white']};
        }
    }

    a {
        cursor: pointer;
        font-weight: ${props => props.theme['$font-weight-medium']};

        &:visited {
            color: ${props => props.theme['$purple']};
        }
    }

    /* adjust icons with svg format to manage it in css styles*/
    path[fill="none"], g[fill="none"], circle[fill="none"] {
        stroke: currentColor;
    }

    [stroke-width]:not([stroke='none']),
    [stroke-linecap]:not([stroke='none']),
    [stroke-dasharray]:not([stroke='none']) {
        stroke: currentColor;
    }
`
// Proper variables for bootstrap styled theme
const overTheme = {
    // general
    '$component-active-bg': transformed['$gray-dark'],
    // Navbar
    '$zindex-navbar': '99',
    '$navbar-padding-y': '0',
    '$navbar-toggler-padding-x': '0',
    // Form
    '$custom-file-text': {
        placeholder: {
            // eslint-disable-line quote-props
            en: 'Choose file...' // eslint-disable-line quote-props
        },
        'button-label': {
            en: 'Browse' // eslint-disable-line quote-props
        }
    }
}

// Custom theme variables
const customTheme = {
    // custom
    '$sidebar-width': math.divide('50rem', rmUnit(transformed['$global-font-size'])),
    '$layout-inner-padding-y': math.divide(transformed['$topbar-height'], 2),
    // caret
    '$caret-color': false, //transformed['$primary'],
    // dropdown
    '$dropdown-menu-border-width': '1px'
}

// Switch styles utilities for enable/disable feature from bootstrap styled library
export const utilities = {
    align: true,
    background: true,
    border: true,
    clearfix: true,
    cursor: true,
    display: true,
    flex: true,
    float: true,
    position: true,
    screenreaders: true,
    sizing: true,
    spacing: false, // To fix an issues this utils is disabled by default, another way its used by ourselve
    text: true,
    transition: true,
    visibility: true
}

// Final theme variables for app
const makeAppTheme = createMakeTheme([
    makeTheme,
    toMakeTheme(transformed),
    toMakeTheme(overTheme),
    toMakeTheme(customTheme)
])
export const appTheme = makeAppTheme({})

export default makeAppTheme
